// Module
var code = "<button type=\"button\" class=\"tw-text-sm tw-text-yellow hover:tw-text-yellow-lighter focus:tw-outline-none\"\n        aria-label=\"{{ $ctrl.title }}\" data-ng-click=\"$ctrl.change($event)\">\n    <i class=\"tw-text-sm fa fa-plus\"></i> {{ ::$ctrl.title }}\n</button>";
// Exports
module.exports = code;